<template>
    <div id="login" ref="login">
        <div class="alert alert-danger" v-if="hasErrors">
            <div v-for="(error, index) in errors" :key="index">
                {{$t(error)}}
            </div>
        </div>
        <div class="alert alert-primary" v-if="hasInfo">
            {{info}}
        </div>
        <form action="" method="post" @submit="formSubmit" v-if="$store.getters['configStore/getLoginModuleStatus']">
            <div class="form-group" v-for="input in inputs" v-bind:key="input.key">
                <input :class="input.class" :type="input.type"
                       v-model="credentials[input.model]"
                       :placeholder="$t(input.placeholder)"
                       :autocomplete="$t(input.placeholder)"/>
            </div>
            <div class="form-group">
                <div class="col-6 float-left">
                    <span class="small-text text-black-50">{{$t('components.login.wacc-text')}}</span>
                    <a :href="`https://accounts.wellis.com/${$store.getters['langStore/current']}`">
                        <img class="img-fluid w-75 wacc-logo" :src="require('@/assets/wacc_logo.png')"/>
                    </a>
                </div>
                <button class="btn btn-wos-real wos__btn-primary_outline col-6 float-right" type="submit">
                    {{$t('components.login.button.login')}}
                </button>
            </div>
        </form>
        <div v-else>
            <p v-if="disabledLogin" class="login-disabled">{{$t('components.login.disabled')}}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "Login",

    mounted() {
        setTimeout(() => {
            this.disabledLogin = this.$store.getters['configStore/getLoginModuleStatus'] === false;
        }, 700);
    },

    data() {
        return {
            disabledLogin: false,
            errors: [],
            info: null,
            credentials: {
                username: null,
                password: null,
            },
            inputs: [
                {
                    key: 'username',
                    type: 'email',
                    class: 'form-control',
                    model: 'username',
                    required: true,
                    placeholder: 'components.login.inputs.username.placeholder',
                    autocomplete: 'off',
                },
                {
                    key: 'password',
                    type: 'password',
                    class: 'form-control',
                    model: 'password',
                    required: true,
                    placeholder: 'components.login.inputs.password.placeholder',
                    autocomplete: 'new-password',
                }
            ]
        }
    },

    methods: {
        formValidate() {
            this.errors = [];
            return new Promise(resolve => {
                this.inputs.forEach(input => {
                    if (input.required) {
                        if (this.credentials[input.model] === null || this.credentials[input.model].length === 0) {
                            this.errors.push('components.login.validation.' + input.model + '.required');
                        }
                    }
                });
                if (this.errors.length === 0) {
                    resolve(this.credentials);
                }
            });
        },

        formSubmit(event) {
            event.preventDefault();
            this.formValidate()
                .then(this.login);
        },

        login(credentials) {
            this.$parent.$refs.langPicker.$el.classList.add('z-index-minus');
            let loader = this.$loading.show({
                container: this.$refs.login,
                opacity: 0.4
            });
            this.info = this.$t('components.login.infoText');
            this.$store.dispatch('authStore/login', credentials)
                .then(() => {
                    this.$store.dispatch('categoryStore/clearCache')
                        .then(() => this.$router.push({name: 'app.start'}));
                })
                .catch(error => {
                    if (!error.response || error.response.data.message !== 'INVALID_USERNAME_OR_PASSWORD') {
                        this.errors.push('whoops');
                    } else {
                        this.errors.push('components.login.validation.invalidCredentials');
                    }
                })
                .finally(() => {
                    this.info = null;
                    loader.hide();
                    loader = null;
                    this.$parent.$refs.langPicker.$el.classList.remove('z-index-minus');
                });
        }
    },

    computed: {
        hasErrors() {
            return this.errors.length > 0;
        },

        hasInfo() {
            return this.info !== null && this.info.length > 0;
        }
    }
}
</script>

<style scoped>

.form-control {
    background: none !important;
    outline: none !important;
    border-width: 0 0 1px;
    border-color: #000000;
    box-shadow: none !important;
    border-radius: 4px;
}

.form-control:focus {
    border-color: #b89453;
    box-shadow: none !important;
}

.login-disabled {
    font-size: 22px;
    color: #e62f06 !important;
}

.small-text {
    font-size: 13px;
}

.wacc-logo {
    opacity: 0.7;
    cursor: pointer;
}

.wacc-logo:hover {
    opacity: 1;
}
</style>
